// Erreur en web si on importe cette fonction directement car utilise des librairies icompatibles web
const ensureCached = (url: string) => Promise.resolve()

export { ensureCached }
